import { IMG } from "./site";

export const SERVICES = [
  {
    slug: "tyre-fitting",
    shortName: "Tyre Fitting",
    title: "Mobile Tyre Fitting",
    tagline: "At home, at work, or stranded roadside — we come to you.",
    heroLines: ["TYRES FITTED", "WHEREVER", "YOU ARE."],
    image: IMG.fitting,
    imageAlt: IMG.fitting2,
    excerpt:
      "One call and a fully equipped tyre van is on its way to you. New tyres supplied, fitted, balanced and old tyres taken away — without you moving your car an inch.",
    intro: [
      "A flat tyre should never cost you a day. Motion Tyres runs fully equipped mobile fitting vans across twelve UK regions, carrying a full range of tyres from budget to premium — Michelin, Pirelli, Continental, Goodyear, Dunlop and Bridgestone among them. You tell us your registration number, we confirm the correct tyre for your vehicle, and a qualified technician is dispatched to your driveway, office car park or motorway hard shoulder.",
      "Every fitting is done to the standard you would expect from a premium workshop: wheels are removed with calibrated impact tools, new tyres are mounted and dynamically balanced, a fresh valve is fitted, and every bolt is torqued to the manufacturer's specification. We finish with a pressure check on all four tyres and take your old tyres away for responsible recycling. The whole visit usually takes well under an hour.",
    ],
    included: [
      "Supply and fit of tyres from all major brands",
      "Dynamic wheel balancing on every new tyre",
      "New valve fitted as standard",
      "Bolts torqued to manufacturer specification",
      "Pressure and condition check on all four tyres",
      "Old tyre disposal and recycling included",
    ],
    process: [
      { n: "01", t: "Call or WhatsApp", d: "Send your registration and location. We confirm the right tyre and a fixed quote." },
      { n: "02", t: "We dispatch", d: "The nearest van heads your way — typical response of 30 to 60 minutes across our areas." },
      { n: "03", t: "We fit on the spot", d: "Mount, balance, torque, pressure-check. Done at your location, whatever the hour." },
      { n: "04", t: "You drive away", d: "Old tyres recycled, workmanship checked, receipt in your hand. Simple as that." },
    ],
    signsTitle: "When to call us",
    signs: [
      "Your tyre is flat, losing pressure overnight, or visibly damaged",
      "You've been quoted a wait of days at a garage — we usually come same day",
      "You can't put a spare on safely at the roadside",
      "Two or more tyres are close to the legal 1.6 mm tread limit",
      "A bulge, crack or puncture picked up on your daily walk-around",
      "You simply want new tyres fitted without losing a day at a garage",
    ],
    faqs: [
      {
        q: "How quickly can you reach me?",
        a: "Across our coverage areas we aim for a 30 to 60 minute response, day or night. In peak traffic or severe weather it can run slightly longer — we'll give you an honest ETA when you call.",
      },
      {
        q: "Can you fit tyres at my workplace?",
        a: "Yes. Driveways, office car parks, on-street bays and roadside hard shoulders are all routine for us. Just tell us where the car is and any access details when you book.",
      },
      {
        q: "Do you carry tyres for my car?",
        a: "Our vans stock the most common sizes across budget, mid-range and premium brands. Send your registration in advance and we'll confirm exact availability and price before dispatch.",
      },
      {
        q: "What does it cost?",
        a: "Pricing depends on tyre size and brand. You'll always get a fixed quote up front on WhatsApp or by phone — no surprises when the van arrives.",
      },
    ],
  },
  {
    slug: "puncture-repair",
    shortName: "Puncture Repair",
    title: "Emergency Puncture Repair",
    tagline: "Safe, standards-compliant repairs — wherever you're stranded.",
    heroLines: ["PUNCTURE?", "WE'RE ALREADY", "ON THE WAY."],
    image: IMG.puncture,
    imageAlt: IMG.fitting2,
    excerpt:
      "Nail in the tyre? Slow leak ruining your week? Our technicians repair punctures to BS AU 159 standards at your location — and if a tyre can't be safely repaired, we fit a new one on the spot.",
    intro: [
      "Not every puncture means a new tyre. A properly executed repair — a plug-patch applied from the inside, sealed and pressure-tested — can safely return a damaged tyre to the road for the rest of its life. Our vans carry the full repair kit: plugs, patches, valves, sealants and compressors, so the assessment and repair happen at your location in one visit.",
      "We repair to the BS AU 159 British Standard, which means we only repair punctures in the safe zone of the tyre — the central three-quarters of the tread — and never on the sidewall or shoulder. If the damage falls outside a safe repair, we'll say so honestly and fit you a new tyre there and then from stock. Either way, you're rolling again within the hour.",
    ],
    included: [
      "Full puncture assessment and safety check",
      "BS AU 159 compliant plug-patch repairs",
      "Valve replacement if required",
      "Wheel re-inflation to correct pressure",
      "Honest assessment — repair or replace advice",
      "New tyre fitted from stock if unrepairable",
    ],
    process: [
      { n: "01", t: "Tell us what happened", d: "Call or WhatsApp with your location and registration. A photo of the tyre helps us pre-load the right kit." },
      { n: "02", t: "Rapid response", d: "We prioritise stranded drivers. Typical roadside arrival is 30 to 60 minutes across our areas." },
      { n: "03", t: "Assess & repair", d: "The tyre comes off, the damage is measured, and a safe repair is completed to British Standard." },
      { n: "04", t: "Pressure-tested & done", d: "We inflate, check for leaks and confirm the repair holds before we leave you." },
    ],
    signsTitle: "Signs you have a puncture",
    signs: [
      "The car pulls to one side or the steering feels heavy",
      "Tyre pressure warning light on your dashboard",
      "A slow leak — the same tyre needs air every few days",
      "You can hear a hissing sound or feel a rhythmic thump",
      "You hit a kerb, pothole or ran over debris",
      "The tyre looks visibly soft or flat",
    ],
    faqs: [
      {
        q: "Can every puncture be repaired?",
        a: "No — and we'll be straight with you. Punctures in the sidewall, shoulder or over 6mm in the tread cannot be repaired safely under BS AU 159. In that case we fit a new tyre on the spot rather than put a dangerous repair on your car.",
      },
      {
        q: "Is a repaired tyre as good as new?",
        a: "A compliant plug-patch repair in the safe zone restores full serviceability for the remaining life of the tyre. It's the same standard a main dealer workshop would apply.",
      },
      {
        q: "I've got run-flat tyres — can you help?",
        a: "Yes. We can assess run-flats at the roadside. Many manufacturers advise against repairing run-flats, so we'll inspect and advise honestly, and fit a replacement if needed.",
      },
      {
        q: "How long does a repair take?",
        a: "A standard repair usually takes 20 to 30 minutes once we're with you. If a replacement tyre is needed, add the normal fitting time.",
      },
    ],
  },
  {
    slug: "wheel-alignment",
    shortName: "Wheel Alignment",
    title: "Mobile Wheel Alignment",
    tagline: "Laser-precise alignment that comes to your driveway.",
    heroLines: ["PULLING", "TO ONE SIDE?", "THAT'S ALIGNMENT."],
    image: IMG.alignment,
    imageAlt: IMG.alignment2,
    excerpt:
      "Uneven tyre wear, a crooked steering wheel or a car that drifts left — our mobile laser alignment service corrects your camber, castor and toe at your home or office, saving your tyres and your fuel.",
    intro: [
      "Wheel alignment — tracking, as most drivers know it — is the invisible service that decides how long your tyres live. Hit a pothole or kerb and your wheels can be knocked out of true by degrees you'll never see. The result: tyres scrubbing away on one edge, fuel economy dropping, and a car that never quite wants to go straight.",
      "Our technicians bring laser alignment equipment to you. We measure toe, camber and castor against your manufacturer's settings, adjust what's out of spec, centre your steering wheel and confirm the readings. Done properly, an alignment can add thousands of miles to the life of a set of tyres — and it costs a fraction of replacing them early.",
    ],
    included: [
      "Full laser measurement of toe, camber and castor",
      "Comparison against manufacturer specification",
      "Adjustment of tracking to factory settings",
      "Steering wheel centring",
      "Tyre wear pattern inspection and advice",
      "Before-and-after readings explained",
    ],
    process: [
      { n: "01", t: "Describe the symptoms", d: "Pulling, wandering or uneven wear? Tell us the car and we'll bring the right equipment." },
      { n: "02", t: "We measure", d: "Laser readings are taken on your driveway or in your office car park — no ramps needed." },
      { n: "03", t: "We adjust", d: "Tracking is corrected to manufacturer spec and the steering wheel is centred." },
      { n: "04", t: "Proof in the readings", d: "We show you before-and-after numbers so you know exactly what changed." },
    ],
    signsTitle: "Symptoms of bad alignment",
    signs: [
      "The car pulls or drifts to one side on a flat road",
      "Your steering wheel sits off-centre when driving straight",
      "Tyres wearing noticeably faster on the inner or outer edge",
      "New tyres wearing badly within months of fitting",
      "Steering feels loose, vague or overly nervous",
      "You've recently hit a pothole, kerb or speed bump hard",
    ],
    faqs: [
      {
        q: "How often should alignment be checked?",
        a: "Once a year is a good habit, and always after a significant impact or when new tyres are fitted. If your tyres are wearing evenly and the car tracks straight, you're in good shape.",
      },
      {
        q: "Can you really do it mobile?",
        a: "Yes. Laser alignment equipment is portable, and flat, level ground — like most driveways and car parks — is all we need for accurate measurement and adjustment.",
      },
      {
        q: "Does alignment fix vibration?",
        a: "Vibration at speed is usually balance, not alignment — and we check and correct wheel balance too. Alignment fixes pulling, wandering and uneven wear. We'll diagnose which you actually need.",
      },
      {
        q: "How long does it take?",
        a: "A standard four-wheel alignment check and adjustment typically takes 40 to 60 minutes at your location.",
      },
    ],
  },
  {
    slug: "summer-tyres",
    shortName: "Summer Tyres",
    title: "Performance Summer Tyres",
    tagline: "Maximum grip when the temperature climbs above 7°C.",
    heroLines: ["GRIP THAT", "LOVES", "WARM TARMAC."],
    image: IMG.summer,
    imageAlt: IMG.hero,
    excerpt:
      "Summer tyres are engineered with a harder compound and tread pattern optimised for warm, dry and wet roads — sharper handling, shorter braking, and quieter motorway miles. Supplied and fitted at your door.",
    intro: [
      "From late spring to early autumn, a dedicated summer tyre outperforms an all-season in every metric that matters: braking distance in the dry, aquaplaning resistance in a downpour, cornering stability and road noise. The compound stays firm and precise as temperatures rise, which is exactly what performance handling and short stopping distances are made of.",
      "We supply the full spectrum — from value brands for the daily commute to ultra-high-performance fits for performance cars — including Michelin Pilot series, Pirelli P Zero, Continental SportContact and Goodyear Eagle F1. Send your registration and we'll match the correct size and load rating, then fit and balance them at your home or workplace, usually within the hour.",
    ],
    included: [
      "Full range: value, mid-range and premium brands",
      "Correct size, speed and load rating for your car",
      "Fitting and dynamic balancing at your location",
      "Pressure set to manufacturer specification",
      "TPMS reset where fitted",
      "Old summer tyres stored or recycled — your choice",
    ],
    process: [
      { n: "01", t: "Send your reg", d: "We match summer tyres in your exact size, from budget to ultra-high performance." },
      { n: "02", t: "Fixed quote", d: "Straight pricing per tyre including fitting, balancing and disposal. No hidden extras." },
      { n: "03", t: "Fitted at your door", d: "Mounted, balanced and torqued at your home, office or wherever suits." },
      { n: "04", t: "Season-ready", d: "TPMS reset, pressures set, and you're set up for the warm months." },
    ],
    signsTitle: "Why fit summer tyres",
    signs: [
      "You want the shortest possible braking in dry conditions",
      "Your car wears all-season tyres quickly in hot months",
      "You drive a performance car that deserves performance rubber",
      "Road noise and comfort matter on long motorway runs",
      "You switch tyres seasonally and want effortless changeovers",
      "Your current tyres are perished, aged or past their best",
    ],
    faqs: [
      {
        q: "When should summer tyres go on?",
        a: "A common UK routine is around Easter through October, when temperatures hold above 7°C. We can advise based on your mileage and when you book.",
      },
      {
        q: "Are summer tyres safe in rain?",
        a: "Yes — a quality summer tyre is excellent in warm wet conditions, with tread patterns designed to move water fast. What they're not built for is ice and snow below 7°C; that's winter tyre territory.",
      },
      {
        q: "Do you take my old tyres away?",
        a: "Yes, disposal is included. If you're running seasonal changeovers, ask about our switchover service and we can discuss keeping a set ready for you.",
      },
      {
        q: "Which brands do you stock?",
        a: "Michelin, Pirelli, Continental, Goodyear, Dunlop, Bridgestone and more, plus trusted value brands. Availability for your exact size is confirmed when you send your registration.",
      },
    ],
  },
  {
    slug: "winter-tyres",
    shortName: "Winter Tyres",
    title: "Winter & Cold-Weather Tyres",
    tagline: "Serious traction below 7°C — fitted without you leaving the house.",
    heroLines: ["BUILT FOR", "ICE, RAIN &", "BRITISH WINTERS."],
    image: IMG.winter,
    imageAlt: IMG.detail,
    excerpt:
      "Winter tyres don't just handle snow. Their silica-rich compound and deep siping stay supple below 7°C, cutting braking distances on cold, wet and icy roads. We fit them at your door before the frost arrives.",
    intro: [
      "The secret of a winter tyre is temperature, not snow. Once the mercury drops below 7°C — which is most UK mornings between October and March — the rubber in a summer tyre hardens and grip falls away. A winter compound stays flexible, and its dense network of sipes bites into cold, wet and frosty tarmac, shortening braking distances dramatically when it matters most.",
      "We fit winter tyres at your home or workplace across all twelve of our regions, and we'll flag it early: demand spikes at the first cold snap, so booking in autumn gets you the pick of sizes and brands. From Michelin Alpin and Continental WinterContact to Goodyear UltraGrip, we carry the proven names — fitted, balanced and torqued on your driveway.",
    ],
    included: [
      "3PMSF-certified winter tyres from leading brands",
      "Fitting and balancing at your home or office",
      "Pressure set for cold-weather conditions",
      "TPMS reset where fitted",
      "Tread depth and condition check on all tyres",
      "Old tyres taken away for recycling",
    ],
    process: [
      { n: "01", t: "Book before the rush", d: "Autumn bookings get the best size availability. Send your registration to reserve." },
      { n: "02", t: "Choose your compound", d: "We quote across brands and price points for your exact winter driving." },
      { n: "03", t: "Fitted at your door", d: "No icy garage queues — we swap and balance them on your driveway." },
      { n: "04", t: "Winter-proof", d: "Pressures set, TPMS reset, and advice on when to switch back in spring." },
    ],
    signsTitle: "Why fit winter tyres",
    signs: [
      "Morning frost, ice or snow on your regular routes",
      "You drive on rural or ungritted roads",
      "Braking distances in cold rain worry you",
      "Your car runs performance summer tyres year-round",
      "You live on a hill or a road that never sees a gritter",
      "You want the safest possible commute from November to March",
    ],
    faqs: [
      {
        q: "Do I need winter tyres in the UK?",
        a: "They're not compulsory, but below 7°C they outperform summer tyres in braking and traction on every cold surface — not just snow. For early-morning commutes and rural routes, many drivers consider them essential.",
      },
      {
        q: "Can I keep winter tyres on all year?",
        a: "We don't recommend it — warm weather softens the compound and wears them quickly. Our seasonal switchover service makes the twice-yearly swap a five-minute job at your door.",
      },
      {
        q: "Do winter tyres ruin my alloys?",
        a: "No. Fitted and balanced correctly — as we always do — they're no harder on wheels than any other tyre. Some drivers keep a set of budget wheels for winter; we can fit to those too.",
      },
      {
        q: "How do I spot a true winter tyre?",
        a: "Look for the three-peak mountain flake (3PMSF) symbol on the sidewall — it certifies tested winter performance. Everything we fit as a winter tyre carries it.",
      },
    ],
  },
  {
    slug: "seasonal-tyres",
    shortName: "Seasonal Tyres",
    title: "Seasonal Tyre Switchover",
    tagline: "Summer set off, winter set on — in your driveway, in under an hour.",
    heroLines: ["SWITCH", "SEASONS,", "NOT PLANS."],
    image: IMG.seasonal,
    imageAlt: IMG.rim,
    excerpt:
      "Run two sets of tyres? Our seasonal switchover brings the right set to you each spring and autumn — swapped, balanced and pressure-set on your driveway, with reminders so you never miss the window.",
    intro: [
      "If you run summer tyres in the warm months and winters through the cold, the changeover days are the hassle: two garage trips, hours in a waiting room, twice a year. Motion Tyres collapses the whole thing into a single visit at your home. We swap the sets, balance the freshly fitted wheels, set pressures to spec and reset your TPMS — done before your coffee goes cold.",
      "It's the smart way to run a performance or EV car that deserves proper rubber all year. Book your spring and autumn slots with us and we'll hold your preferred dates, remind you as each window approaches, and keep the process to a single technician visit each time. Storage arrangements can be discussed when you book if you don't have space at home.",
    ],
    included: [
      "Full swap of summer and winter wheel sets",
      "Dynamic balancing of every fitted wheel",
      "Pressures set to manufacturer specification",
      "TPMS reset and sensor check",
      "Tread and condition report on the off-going set",
      "Seasonal reminders so you never miss the window",
    ],
    process: [
      { n: "01", t: "Register for the year", d: "Tell us your car and both wheel sets. We note your details and preferences." },
      { n: "02", t: "We remind you", d: "A nudge in spring and autumn when conditions are right to switch." },
      { n: "03", t: "Driveway swap", d: "One visit, one hour: wheels swapped, balanced, torqued and pressures set." },
      { n: "04", t: "Report & go", d: "We flag any wear worth watching on the stored set before it goes back on." },
    ],
    signsTitle: "Switchover makes sense if",
    signs: [
      "You run separate summer and winter tyre sets",
      "You want maximum performance and safety in both seasons",
      "Your garage or workshop trips eat your mornings",
      "You drive a performance car or EV with specific tyre needs",
      "You keep wheels in the garage and dread the twice-yearly job",
      "You want professional balancing on every seasonal swap",
    ],
    faqs: [
      {
        q: "How long does a switchover take?",
        a: "A four-wheel seasonal swap with balancing is usually complete within the hour, at your home or workplace.",
      },
      {
        q: "Do you store my off-season tyres?",
        a: "Storage options vary by area — ask when you book and we'll talk through what's possible, or we simply leave the off-going set with you.",
      },
      {
        q: "Is balancing really necessary on a swap?",
        a: "Yes. Wheels can lose balance weights over a season, and an unbalanced set shows up as vibration within weeks. Every fitted wheel is balanced as standard.",
      },
      {
        q: "When are the best switch dates?",
        a: "Most UK drivers switch to winters around October when temperatures settle below 7°C, and back to summers around Easter. We'll remind you when the window is right.",
      },
    ],
  },
];

export const getService = (slug) => SERVICES.find((s) => s.slug === slug);
